/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Extraparticipationconstraints2Inputs */

const en__field_extraparticipationconstraints2 = /** @type {(inputs: _Field_Extraparticipationconstraints2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participation Constraints`)
};

const de__field_extraparticipationconstraints2 = /** @type {(inputs: _Field_Extraparticipationconstraints2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedingungen für eine erfolgreiche Teilnahme`)
};

/**
* | output |
* | --- |
* | "Participation Constraints" |
*
* @param {_Field_Extraparticipationconstraints2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_extraparticipationconstraints2 = /** @type {((inputs?: _Field_Extraparticipationconstraints2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Extraparticipationconstraints2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_extraparticipationconstraints2(inputs)
	return de__field_extraparticipationconstraints2(inputs)
});
export { _field_extraparticipationconstraints2 as "_field_extraParticipationConstraints" }